type ProductTitleParams = {
  genderCode?: string;
  genderCodeAndGenderDesc?: string;
  itemCode?: string;
  mainFabricCode?: string;
  colorCode?: string;
  itemColorCode?: string;
};

/**
 * Product details title, e.g. `"MU 11000016W 4LP 68"` — the same short gender
 * code the colours list shows. The URL carries the gender as
 * `"MU - MODELLI UOMO/UNISEX"`, so only the code before the first `" - "` is kept.
 * Missing parts are skipped.
 */
export const buildProductTitle = ({
  genderCode,
  genderCodeAndGenderDesc,
  itemCode,
  mainFabricCode,
  colorCode,
  itemColorCode,
}: ProductTitleParams): string => {
  const gender = genderCode ?? genderCodeAndGenderDesc?.split(' - ')[0];

  return [gender, itemCode, mainFabricCode, colorCode ?? itemColorCode]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(' ');
};
